import React from "react";
import { Typography, Button } from "design_system/src";
import { ReactComponent as RightArrow } from "design_system/src/static/icons/up-lg.svg";
import { scrollToSectionWithOffset } from "views/VehicleDetail/helpers/scrolling";
import ReviewScore from "./ReviewScore";

interface ReviewsSummaryProps {
  value: number;
  amount: number;
}

const ReviewsSummary = ({ value, amount }: ReviewsSummaryProps) => {
  const scrollToSection = () => {
    scrollToSectionWithOffset("reviews-section");
  };

  return (
    <div className="display_flex flex_align_center flex_gap_md">
      <Typography weight="400" scale="small" className="text_neutral_600">{value.toFixed(1)}</Typography>
      <ReviewScore value={value} />
      <Button variant="ghost" scale="small" onClick={scrollToSection}>
        <div className="display_flex flex_align_center flex_gap_sm">
          <Typography weight="400" scale="small" className="text_neutral_600">({amount})</Typography>
          <RightArrow className="text_primary_300 w_md" style={{ "transform": "rotate(90deg)"}}/>
        </div>
      </Button>
    </div>
  );
};

export default ReviewsSummary;
